import React from 'react'
import styled from '@emotion/styled'
import { node, object, string } from 'prop-types'

import { MetaData } from '../MetaData'
import { ResetCss } from '@jelly/ui'

// Styled Components via Emotion
const AppWrapper = styled.div`
	height: 100%;
	width: 100%;

	/* For border-box across all child elements } */
	* {
		box-sizing: ${({ boxSizing }) => boxSizing};
	}
`

PageWrapper.propTypes = {
	boxSizing: string,
	children: node.isRequired,
	meta: object,
}
/**
 * PageWrapper, wrap any template in this for meta data and the css reset to be applied
 * @param {string} props.boxSizing :: box sizing value
 * @param {Node} props.node :: rest of the app or page
 * @param {Object} props.meta :: all the meta data related to the page
 */
export function PageWrapper({ boxSizing = 'border-box', children, meta = {} }) {
	return (
		<AppWrapper boxSizing={boxSizing}>
			<MetaData meta={meta} />
			<ResetCss />
			{children}
		</AppWrapper>
	)
}
